import React from "react";
import { Link } from "gatsby";
import classnames from "classnames";
import { ImageDataLike } from "gatsby-plugin-image";
import { IContentfulLink } from "../../types/IContentfulLink";

import { IContentfulImage } from "../../types/IContentfulImage";
import "./styles.scss";
import { GatsbyImageOrSvg } from "../../utils/GatsbyImageOrSvg/GatsbyImageOrSvg";

interface IGuideCardProps {
  title: string,
  category: string,
  url: IContentfulLink,
  backgroundImage: IContentfulImage & ImageDataLike,
  backgroundColor: string
}

const GuideCard: React.FC<IGuideCardProps> = ({
  title,
  category,
  url,
  backgroundColor,
  backgroundImage,
}) => {
  const guideCardTextContainerInnerClasses = classnames(
    "guide-card-text-container-inner",
    { "guide-card-text-container-inner-purple": backgroundColor === "purple" },
    { "guide-card-text-container-inner-yellow": backgroundColor === "yellow" },
    { "guide-card-text-container-inner-red": backgroundColor === "red" },
    { "guide-card-text-container-inner-gray": backgroundColor === "gray" },
    { "guide-card-text-container-inner-green": backgroundColor === "green" },
    { "guide-card-text-container-inner-blue": backgroundColor === "blue" },
  );

  return (
    <div className="guide-card">
      <GatsbyImageOrSvg image={backgroundImage} loading="lazy" alt={backgroundImage.title} />
      <Link to={url.url}>
        <div className="guide-card-text-container">
          <div className={guideCardTextContainerInnerClasses} data-testid="colorful-background">
            <span className="guide-card-text-container-inner-category">{category}</span>
            <h3 className="guide-card-text-container-inner-title">{title}</h3>
          </div>
        </div>
      </Link>
    </div>
  );
};

export { GuideCard, IGuideCardProps };
